module.exports = __webpack_public_path__ + "img/216.2962d347.png";